import React from 'react';
import { Modal, Button } from '@sw-sw/lib-ui';
import './InspectionTypeModal.scss';

interface InspectionTypeModalProps {
  show: boolean;
  onClose: () => void;
  onSelectAssignedForm: () => void;
  onSelectOneTime: () => void;
}

const InspectionTypeModal: React.FC<InspectionTypeModalProps> = ({
  show,
  onClose,
  onSelectAssignedForm,
  onSelectOneTime,
}) => {
  if (!show) return null;

  return (
    <Modal
      show={show}
      title="Schedule Inspection"
      handleClose={onClose}
    >
      <div className="inspection-type-modal-content">
        <p className="inspection-type-modal-description">
          Choose the type of inspection you would like to schedule:
        </p>
        
        <div className="inspection-type-options">
          <div 
            className="inspection-type-card"
            onClick={onSelectAssignedForm}
          >
            <div className="inspection-type-icon">
              <i className="fa fa-clipboard-list" aria-hidden="true"></i>
            </div>
            <h4>Assigned Forms</h4>
            <p>Create an inspection from one of the currently assigned forms for this project.</p>
            <Button className="primary">
              Select
            </Button>
          </div>

          <div 
            className="inspection-type-card"
            onClick={onSelectOneTime}
          >
            <div className="inspection-type-icon">
              <i className="fa fa-calendar-plus" aria-hidden="true"></i>
            </div>
            <h4>One Time Inspection</h4>
            <p>Schedule a one-time inspection with custom settings.</p>
            <Button className="primary">
              Select
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InspectionTypeModal;
